import React from "react";
import { useQuerySharedFileSettings } from "../../../../../../query/sharedFile/query/useQuerySharedFileSettings";
import { mimeTypesToGroups } from "../../../../../RequirementDefinitions/modules/SharedFile/createRequirementDefinition/utils";
import { WSQueries } from "../../../../../../query/WSQuery";
import { RequirementCardContent } from "../../../../components/RequirementCardContent";
import {
  SharedFileRequestContextType,
  SharedFileRequestStatus
} from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { WSInfoBox, WSList, WSText } from "@wingspanhq/fe-component-library";
import { useRequirementInstructionsModal } from "../../../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";

export const UploadNewFileInstructions = ({
  contextType,
  sharedFileRequestSettingsId,
  requirementId,
  status
}: {
  status: SharedFileRequestStatus | undefined;
  contextType?: SharedFileRequestContextType;
  sharedFileRequestSettingsId: string;
  requirementId: string;
}) => {
  const querySharedFileSettings = useQuerySharedFileSettings(
    sharedFileRequestSettingsId
  );

  const requirementInstructionsModal = useRequirementInstructionsModal();

  return (
    <WSQueries queries={{ querySharedFileSettings }}>
      {({ querySharedFileSettingsData }) => {
        return (
          <WSList gap="M">
            {querySharedFileSettingsData.instructions &&
            contextType === SharedFileRequestContextType.None ? (
              <WSInfoBox>
                <WSText.ParagraphXs as="pre" color="gray600">
                  {querySharedFileSettingsData.instructions}
                </WSText.ParagraphXs>
              </WSInfoBox>
            ) : null}

            {querySharedFileSettingsData?.contextType !==
              SharedFileRequestContextType.None && (
              <WSInfoBox>
                Review the{" "}
                <a
                  href="#"
                  onClick={async () =>
                    await requirementInstructionsModal.open({ requirementId })
                  }
                >
                  instructions
                </a>{" "}
                and upload your file
              </WSInfoBox>
            )}

            <RequirementCardContent
              type="documents"
              title="File not uploaded"
              description={
                <WSList gap="XS">
                  <WSText.ParagraphXs weight="medium" color="gray600">
                    Accepted formats:
                  </WSText.ParagraphXs>
                  {mimeTypesToGroups(
                    querySharedFileSettingsData?.mimeTypes || []
                  ).map(typeDescription => (
                    <WSText.ParagraphXs key={typeDescription} color="gray600">
                      {typeDescription}
                    </WSText.ParagraphXs>
                  ))}
                  <WSText.ParagraphXs color="gray600">
                    Max 100 MB per file
                  </WSText.ParagraphXs>
                </WSList>
              }
            />
          </WSList>
        );
      }}
    </WSQueries>
  );
};
